import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Icon } from "@/components/atoms";
import { DataTableRowProps } from "../types";
import { DataTableCell } from "./DataTableCell";

export const DraggableRow = <T extends object>({ row, isDraggable = true, ...props }: DataTableRowProps<T>) => {
  const { attributes, listeners, setNodeRef, transform } = useSortable({ id: row.id, disabled: !isDraggable });
  const style = {
    transform: CSS.Transform.toString(transform),
  };

  return (
    <tr ref={setNodeRef} style={style} {...props}>
      {row.getVisibleCells().map((cell) => {
        if (cell.column.id === "reorder") {
          return (
            <td key={cell.id} className="font-regular relative px-4 py-2 align-middle text-base text-neutral-black max-lg:p-2">
              {isDraggable && <Icon name="drag" className="outline-none" isCustom {...attributes} {...listeners} />}
            </td>
          );
        } else {
          return (
            <DataTableCell
              key={cell.id}
              cell={cell}
              className="font-regular relative px-4 py-2 align-middle text-base text-neutral-black max-lg:p-2"
            />
          );
        }
      })}
    </tr>
  );
};
